<template>
  <div>
    <button
      type="button"
      class="relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md bg-white focus:outline-none border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
      @click="setShow"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
        />
      </svg>
    </button>

    <Portal to="app-dialog" v-if="show">
      <FilterManager :filters="filters" @hide="closeModal" @update="updateFilters" />
    </Portal>
  </div>
</template>

<script>
import FilterManager from './filter-manager.vue';

export default {
  components: {
    FilterManager,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: false,
      loading: false,
    };
  },
  methods: {
    setShow(show = true) {
      this.show = show;
    },
    closeModal() {
      this.setShow(false);
    },
    setLoading(loading = true) {
      this.loading = loading;
    },
    async updateFilters(filters) {
      if (this.loading) {
        return;
      }

      this.setLoading();

      try {
        this.$emit('loading');

        this.closeModal();
        await this.action(filters);
      } catch (error) {
        // do something
      } finally {
        this.setLoading(false);

        this.$emit('loaded');
      }
    },
  },
};
</script>
